import styled from 'styled-components';

export const ListItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 0 5px;
`;

export const ListItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 5px;
`;

export const ListItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const ListItemTitle = styled.span`
  font-weight: 700;
`;

export const DueDate = styled.span`
  font-weight: 600;
`;

export const TaskType = styled.span`
  color: #344054;
  font-weight: 500;
`;

export const TaskIconWrapper = styled.div`
  display: flex;
  margin-top: 3px;
`;

export const TaskDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
